<template>
  <div class="numberInput">
    <input class="input" v-model="model" :min="minValue" :max="maxValue" :step="stepValue" type="number" />
    <div class="input-type" v-html="unit"></div>
  </div>
</template>

<script>
export default {
  name: 'NumberInput',
  props: ['type', 'setter'],
  computed: {
    model: {
      get () {
        return this.$store.state.variables[this.type]
      },
      set (value) {
        // Optional: Make it dynamic
        this.$store.commit(this.setter, parseFloat(value, 10))
      }
    },
    unit: {
      get () {
        return this.$store.getters.getUnitType(this.type)
      }
    },
    minValue: {
      get () {
        return this.$store.getters.getInputMin(this.type)
      }
    },
    maxValue: {
      get () {
        return this.$store.getters.getInputMax(this.type)
      }
    },
    stepValue: {
      get () {
        return this.$store.getters.getInputStep(this.type)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/helpers/number-input.vue